/**
 * Wartownik zapisywany w kolumnie `product.allegrohash` przez webservice Allegro,
 * gdy seria rozmiarowa nie jest (jeszcze) znana. NIE jest identyfikatorem serii —
 * produkty z tą wartością są od siebie niezależne.
 *
 * Backend filtruje go w części ścieżek (ProductSizeEnricher przy doborze rozmiarów,
 * AllegrohashCollapser, ProductDetail), ale w payloadzie listingu i koszyka hash
 * bywa wystawiany SUROWO — dlatego każdy konsument musi go odsiać sam. Puszczony
 * dalej jako `item_group_id` skleiłby w analityce (Segmentify/GA4) tysiące
 * niepowiązanych produktów w jedną grupę.
 */
export const ALLEGROHASH_SENTINEL = 'not known yet'

/**
 * Zwraca hash serii albo `undefined`, gdy produkt nie należy do żadnej serii
 * (hash pusty lub wartownik). Jedno źródło prawdy dla warstwy danych i dedupu.
 */
export function seriesHash(value: unknown): string | undefined {
  const hash = typeof value === 'string' ? value.trim() : ''
  return hash !== '' && hash !== ALLEGROHASH_SENTINEL ? hash : undefined
}
